import React from 'react';
import { motion } from 'framer-motion';
import { XCircle } from 'lucide-react';
const painPoints = ['Te prometés cambiar cada lunes… pero el lunes pasa y seguís igual', 'Arrancás con toda la energía del mundo y a los 3 días ya lo dejaste', 'Scrolleás redes viendo cómo otros avanzan mientras vos seguís en el mismo lugar', 'Sentís que tu vida está en piloto automático y no sabés cómo frenar', 'Te mirás al espejo y no te gusta lo que ves — ni por fuera ni por dentro', 'Sabés que podés dar más… pero algo te frena y no sabés qué es'];
export function ProblemSection() {
  return <section className="py-20 md:py-28 px-4 bg-primary text-warm relative overflow-hidden" data-id="element-165">
      {/* Subtle background pattern */}
      <div className="absolute inset-0 opacity-5" style={{
      backgroundImage: 'radial-gradient(var(--bg-warm) 1px, transparent 1px)',
      backgroundSize: '24px 24px'
    }} data-id="element-166"></div>

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-167">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-168">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-6 text-warm" data-id="element-169">
            ¿Te suena familiar?
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6 mb-12" data-id="element-170">
          {painPoints.map((point, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="flex items-start gap-4 bg-white/5 p-5 rounded-xl border border-white/10 hover:bg-white/10 transition-colors" data-id="element-171">
              <XCircle className="w-6 h-6 text-cta shrink-0 mt-0.5" data-id="element-172" />
              <p className="text-lg text-beige/90 leading-snug" data-id="element-173">{point}</p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.6
      }} className="text-center max-w-2xl mx-auto" data-id="element-174">
          <p className="text-2xl md:text-3xl font-bold text-warm mb-4" data-id="element-175">
            Esto no es falta de voluntad. Es falta de un sistema.
          </p>
          <p className="text-3xl md:text-4xl font-serif italic text-highlight" data-id="element-176">
            Y eso se termina hoy.
          </p>
        </motion.div>
      </div>
    </section>;
}